import React from 'react';


import i_close from '../../UI/Close.png';


import i_loading from '../../UI/Cargando.png'
import i_back from '../../UI/back_simple.png';
import svg_loading from '../../UI/oval.svg'





class Recorrido360Component extends React.Component {



    constructor(props) {
        super(props);
        this.state = {
            
            statusGaleria: 'not rendered',
            indexRender: 0,
            isFirstImg: true,
            isLastImg: true,
            renders: []
            
        };

        this.linksmap = {
            "Tipo A": "https://v9estudio.viewin360.co/share/collection/7kYPY?fs=1&vr=1&zoom=1&thumbs=1&alpha=0.60&inst=es&info=0&logo=bWVkaWEvMTA3NjI2LzYwYzMtNmM2ZS03YTU1LWIxNjIucG5n&logosize=115",
            "Tipo D": "https://v9estudio.viewin360.co/share/collection/7klDJ?fs=1&vr=1&zoom=1&thumbs=1&alpha=0.60&inst=es&info=0&logo=bWVkaWEvMTA3NjI2LzYwYzMtNmM2ZS03YTU1LWIxNjIucG5n&logosize=115",
            "Tipo E": "https://v9estudio.viewin360.co/share/collection/7YtX8?fs=1&vr=1&zoom=1&thumbs=1&alpha=0.60&inst=es&info=0&logo=bWVkaWEvMTA3NjI2LzYwYzMtNmM2ZS03YTU1LWIxNjIucG5n&logosize=115",
            "Apto Tipo A": "https://v9estudio.viewin360.co/share/collection/7kYPY?fs=1&vr=1&zoom=1&thumbs=1&alpha=0.60&inst=es&info=0&logo=bWVkaWEvMTA3NjI2LzYwYzMtNmM2ZS03YTU1LWIxNjIucG5n&logosize=115",
            "Apto Tipo D": "https://v9estudio.viewin360.co/share/collection/7klDJ?fs=1&vr=1&zoom=1&thumbs=1&alpha=0.60&inst=es&info=0&logo=bWVkaWEvMTA3NjI2LzYwYzMtNmM2ZS03YTU1LWIxNjIucG5n&logosize=115",
            "Apto Tipo E": "https://v9estudio.viewin360.co/share/collection/7YtX8?fs=1&vr=1&zoom=1&thumbs=1&alpha=0.60&inst=es&info=0&logo=bWVkaWEvMTA3NjI2LzYwYzMtNmM2ZS03YTU1LWIxNjIucG5n&logosize=115",
        }
    }




    componentDidMount(){
    }


    handleImageLoaded = () => {
        
        this.setState({ statusGaleria: "loaded" });
    }

    handlePrevGaleria = () =>
    {
        let {indexRender} = this.state;
        this.setState({indexRender: indexRender-1, statusGaleria:'loading'});
    }

    //precondicion: solo esta visible si hay algún siguiente
    handleNextGaleria = () =>
    {
    
    }



    render()
    {

        
        let {handleCloseRecorridos360 } = this.props;
        let {statusGaleria, indexRender } = this.state;

        return (

            <div className="slide slide-360">
                {/* <img className='slide-image' src={ i_frame whatever } />   */}
                <div >

                    {/* <img  src={ i_360 } /> */}
                    <iframe onLoad={this.handleImageLoaded.bind(this)}
                    src={this.linksmap[this.props.tourname]}
                    name="TOUR NAME" width="100%" height="100%" 
                    frameBorder="0" 
                    allowFullScreen={true}
                    // allow="fullscreen; accelerometer; gyroscope; magnetometer; vr"
                    ></iframe>

                    
                    {/* tenemos una jugada sucia y es que no quede tan externo de nosotros.. no se ve tan iframe ni la pantalla de carga.. en ese caso que descomente esta linea  */}
                    {/* {statusGaleria !== 'loaded'?
                    <div className="slide-loading"><img className="loader-circle"  src={ svg_loading } /> </div>
                    : <div></div> 
                    }  */}

                </div>
                <div className="slide-ui">
                    <button  className="slide-close" onClick={handleCloseRecorridos360}> <img src={i_close}/></button>
                </div>
            </div>

        );
    }
}

export default Recorrido360Component;